'use client';

const ForCollegesSection = () => {
    return (
        <section className="py-24 bg-surface/30 relative">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center gap-16">

                    {/* Text Content */}
                    <div className="flex-1 order-2 lg:order-1">
                        <span className="text-accent font-semibold tracking-wider uppercase text-sm">For Institutions</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6 text-text-primary">
                            Empower Your <span className="gradient-text">Placement Cell</span>
                        </h2>
                        <p className="text-xl text-text-secondary mb-8 leading-relaxed">
                            Give your institution the competitive edge with real-time analytics, automated placement workflows, and industry-standard training modules.
                        </p>

                        <div className="space-y-6">
                            {[
                                "Real-time student progress tracking dashboard",
                                "Automated placement drive management",
                                "Industry-aligned curriculum suggestions",
                                "Corporate connection facilitation"
                            ].map((item, idx) => (
                                <div key={idx} className="flex items-start gap-4">
                                    <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success mt-1 shrink-0">
                                        ✓
                                    </div>
                                    <div className="text-lg text-text-primary">{item}</div>
                                </div>
                            ))}
                        </div>

                        {/* <button className="mt-10 px-8 py-4 rounded-lg bg-surface hover:bg-surface-hover border border-white/10 text-white font-semibold transition-all hover-lift">
                            Partner With Us
                        </button> */}
                    </div>

                    {/* Visual */}
                    <div className="flex-1 order-1 lg:order-2 relative">
                        <div className="relative z-10 w-full aspect-video glass glass-border rounded-2xl shadow-2xl p-4 overflow-hidden group">
                            <div className="absolute inset-0 bg-gradient-to-tr from-accent/20 to-transparent opacity-50" />
                            {/* Abstract Dashboard UI */}
                            <div className="h-full flex flex-col gap-4">
                                <div className="flex gap-4">
                                    <div className="w-1/3 h-32 bg-white/5 rounded-lg animate-pulse" />
                                    <div className="w-2/3 h-32 bg-white/5 rounded-lg animate-pulse delay-100" />
                                </div>
                                <div className="flex-1 bg-white/5 rounded-lg animate-pulse delay-200" />
                            </div>

                            {/* Hover Overlay */}
                            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <span className="text-white font-bold text-lg border-b-2 border-accent pb-1">View Dashboard</span>
                            </div>
                        </div>

                        {/* Background blobs */}
                        <div className="absolute -top-10 -right-10 w-64 h-64 bg-primary/20 rounded-full blur-[80px] -z-10" />
                        <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-accent/20 rounded-full blur-[80px] -z-10" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ForCollegesSection;
